var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Bluebird from 'bluebird';
import socketService from "../services/socket.service";
import ObjectLoader, { SYMBOL_UNCHANGED } from "../services/mutableObjectLoader";
import ChunkLoader, { Chunk } from "./chatChunk";
import MessageLoader, { Message } from "./message";
import h from "../helper/helper";
import Cache from "../services/Cache";
import keyStore from "../services/keyStore.service";
import Observer from "../asset/observer";
import settings from "../services/settings.service";
import sessionService from "../services/session.service";
var initService = require("services/initService");
var messageSendCache = new Cache("unsentMessages", { maxEntries: -1, maxBlobSize: -1 });
var unreadChatIDs = [];
var addAfterTime = function (arr, id, time) {
    var firstLaterIndex = arr.findIndex(function (ele) { return ele.time > time; });
    if (firstLaterIndex === -1) {
        return arr.concat([
            { id: id, time: time }
        ]);
    }
    return arr.slice(0, firstLaterIndex).concat([
        { id: id, time: time }
    ], arr.slice(firstLaterIndex));
};
var getUnstoredMessages = function () {
    var messagesMap = MessageLoader.getAll() || {};
    var messages = Object.keys(messagesMap).map(function (id) { return messagesMap[id]; });
    return messages.filter(function (m) { return !m.hasBeenSent(); }).filter(function (m) { return m.hasAttachments(); });
};
window.addEventListener("beforeunload", function (e) {
    var confirmationMessage = "Unsent files and images. Leave page anyway?";
    if (getUnstoredMessages().length > 0) {
        var event_1 = e || window.event;
        event_1.returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
    }
    return;
});
var verifyMessageAssociations = function (message, latestChunkID) {
    return Bluebird.all([
        ChunkLoader.get(message.getChunkID()),
        ChunkLoader.get(latestChunkID),
    ]).then(function (_a) {
        var messageChunk = _a[0], latestChunk = _a[1];
        message.verifyParent(messageChunk);
        return Chunk.loadChunkChain(latestChunk, messageChunk).thenReturn([latestChunk, messageChunk]);
    }).then(function (_a) {
        var latestChunk = _a[0], messageChunk = _a[1];
        latestChunk.ensureChunkChain(messageChunk);
    });
};
var Chat = /** @class */ (function (_super) {
    __extends(Chat, _super);
    function Chat(_a, draft) {
        var id = _a.id, latestMessage = _a.latestMessage, latestChunk = _a.latestChunk, unreadMessageIDs = _a.unreadMessageIDs;
        var _this = _super.call(this) || this;
        //Sorted IDs
        _this.messages = [];
        _this.chatUpdates = [];
        _this.chunkIDs = [];
        _this.loadMissingMessagesPromise = Bluebird.resolve();
        _this.waitingMissingMessages = false;
        // Unsorted IDs
        _this.unreadMessageIDs = [];
        _this.draft = false;
        _this.newMessage = "";
        _this.getInfo = function () { return ({
            id: _this.id,
            unreadMessageIDs: _this.unreadMessageIDs,
            latestMessageID: _this.getLatestSentMessage(),
            latestChunkID: _this.getLatestChunk()
        }); };
        _this.store = function () {
            if (_this.draft) {
                return;
            }
            var storeInfo = _this.getInfo();
            if (h.deepEqual(_this.lastStoredInfo, storeInfo)) {
                return;
            }
            _this.lastStoredInfo = storeInfo;
            ChatLoader.updateCache(_this.id, storeInfo);
        };
        _this.create = function (_a) {
            var id = _a.id, latestChunkID = _a.latestChunkID;
            _this.draft = false;
            _this.id = id;
            _this.chunkIDs = [latestChunkID];
            ChatLoader.addLoaded(id, _this);
            ChatLoader.removeLoaded(-1);
        };
        _this.isBlocked = function () {
            if (_this.getReceiverIDs.length > 2) {
                return false;
            }
            var otherReceiver = _this.getReceiverIDs().find(function (id) { return id !== sessionService.getUserID(); });
            return settings.isBlocked(otherReceiver);
        };
        _this.update = function (_a) {
            var latestChunk = _a.latestChunk, latestMessage = _a.latestMessage, unreadMessageIDs = _a.unreadMessageIDs;
            _this.unreadMessageIDs = unreadMessageIDs;
            _this.addChunkID(latestChunk.getID(), false);
            if (latestMessage) {
                _this.addMessage(latestMessage, false);
            }
        };
        _this.getID = function () {
            return _this.id;
        };
        _this.isMessageUnread = function (message) {
            return _this.unreadMessageIDs.indexOf(message.getClientID()) > -1;
        };
        _this.removeMessageID = function (removeID) {
            _this.messages = _this.messages.filter(function (_a) {
                var id = _a.id;
                return removeID !== id;
            });
        };
        _this.addMessage = function (message, updateCache) {
            if (updateCache === void 0) { updateCache = true; }
            _this.addMessageID(message.getClientID(), message.getTime(), updateCache);
            _this.scheduleLoadMissingMessages();
        };
        _this.addMessageID = function (id, time, updateCache) {
            if (updateCache === void 0) { updateCache = true; }
            var alreadyAdded = _this.messages.find(function (message) { return message.id === id; });
            if (alreadyAdded) {
                return;
            }
            _this.messages = addAfterTime(_this.messages, id, time);
            if (updateCache) {
                _this.store();
            }
        };
        _this.verifyMessageAssociations = function (message) {
            return verifyMessageAssociations(message, h.array.last(_this.chunkIDs));
        };
        _this.addChunkID = function (chunkID, updateCache) {
            if (updateCache === void 0) { updateCache = true; }
            if (_this.chunkIDs.indexOf(chunkID) > -1) {
                return;
            }
            _this.chunkIDs = _this.chunkIDs.concat([chunkID]).sort(function (a, b) { return a - b; });
            if (updateCache) {
                _this.store();
            }
        };
        _this.hasMessage = function (id) {
            return _this.messages.find(function (message) { return message.id === id; });
        };
        _this.loadPreviousMessagesFromCache = function (message, limit) {
            if (limit === void 0) { limit = 20; }
            var messagesLoaded = [];
            return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
                var currentMessage, i, previousMessage;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            currentMessage = message;
                            i = 0;
                            _a.label = 1;
                        case 1:
                            if (!(i < limit)) return [3 /*break*/, 5];
                            if (!currentMessage.getPreviousID()) {
                                return [2 /*return*/, messagesLoaded];
                            }
                            return [4 /*yield*/, MessageLoader.getFromCache(currentMessage.getPreviousID())];
                        case 2:
                            previousMessage = _a.sent();
                            return [4 /*yield*/, this.verifyMessageAssociations(previousMessage)];
                        case 3:
                            _a.sent();
                            if (this.hasMessage(previousMessage.getClientID())) {
                                return [2 /*return*/, messagesLoaded];
                            }
                            messagesLoaded.push(previousMessage);
                            currentMessage = previousMessage;
                            _a.label = 4;
                        case 4:
                            i += 1;
                            return [3 /*break*/, 1];
                        case 5: return [2 /*return*/, messagesLoaded];
                    }
                });
            }); }).catch(function () { return messagesLoaded; }).then(function (messages) {
                messages.forEach(function (m) { return _this.addMessage(m); });
                return messages;
            });
        };
        _this.loadMissingMessages = function () {
            return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var batchSizes, iteration, batchSize, _loop_1, this_1, state_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            batchSizes = [1, 3, 10, 20];
                            iteration = 0;
                            _loop_1 = function () {
                                var knownMessages, ids, messagesWithoutPredecessor;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            knownMessages = this_1.messages
                                                .map(function (_a) {
                                                var id = _a.id;
                                                return MessageLoader.getLoaded(id);
                                            })
                                                .filter(function (m) { return m.hasBeenSent(); });
                                            if (knownMessages.length < 2) {
                                                return [2 /*return*/, { value: void 0 }];
                                            }
                                            ids = knownMessages.map(function (m) { return m.getClientID(); });
                                            messagesWithoutPredecessor = knownMessages.filter(function (m) {
                                                return ids.indexOf(m.getPreviousID()) === -1;
                                            }).sort(function (a, b) { return a.getTime() - b.getTime(); });
                                            if (knownMessages.filter(function (m) { return !m.getPreviousID(); }).length > 1) {
                                                console.warn("Got more than one last message in chat. Aborting!");
                                                return [2 /*return*/, { value: void 0 }];
                                            }
                                            if (messagesWithoutPredecessor.length === 1) {
                                                console.warn("No more missing messages");
                                                return [2 /*return*/, { value: void 0 }];
                                            }
                                            console.warn("Loading batch size " + batchSize + " messages. Missing " + messagesWithoutPredecessor.length);
                                            return [4 /*yield*/, Bluebird.all(messagesWithoutPredecessor.map(function (m) {
                                                    return _this.loadOlderMessages(m, batchSize);
                                                }))];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _a.label = 1;
                        case 1:
                            if (!(batchSize = batchSizes[iteration++])) return [3 /*break*/, 3];
                            return [5 /*yield**/, _loop_1()];
                        case 2:
                            state_1 = _a.sent();
                            if (typeof state_1 === "object")
                                return [2 /*return*/, state_1.value];
                            return [3 /*break*/, 1];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        };
        // TODO: Check if this leaks memory
        _this.scheduleLoadMissingMessages = function () {
            if (_this.messages.length < 2) {
                return;
            }
            if (_this.waitingMissingMessages) {
                return;
            }
            _this.waitingMissingMessages = true;
            console.warn("Scheduling missing message check");
            _this.loadMissingMessagesPromise = _this.loadMissingMessagesPromise
                .delay(50)
                .finally(function () {
                _this.waitingMissingMessages = false;
                return _this.loadMissingMessages();
            });
            return _this.loadMissingMessagesPromise;
        };
        _this.loadInitialMessages = h.cacheResult(function () { return _this.loadMoreMessages(); });
        _this.getUnreadMessageIDs = function () {
            return _this.unreadMessageIDs;
        };
        _this.isAdmin = function (user) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.isAdmin(user);
        };
        _this.amIAdmin = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return !_this.isDraft() && latestChunk.amIAdmin();
        };
        _this.getReceivers = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.getReceivers();
        };
        _this.getReceiverIDs = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.getReceiverIDs();
        };
        _this.getTitle = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.getTitle();
        };
        _this.getPartners = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.getPartners();
        };
        _this.removeReceiver = function (receiver) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            var oldReceiverIDs = latestChunk.getReceiver();
            var newReceiverIDs = oldReceiverIDs.filter(function (id) { return id !== receiver.getID(); });
            return _this.createSuccessor(newReceiverIDs, {});
        };
        _this.addAdmin = function (receiver) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            var adminIDs = latestChunk.getAdmins();
            if (adminIDs.indexOf(receiver.getID()) > -1) {
                return Bluebird.resolve();
            }
            return _this.setAdmins(adminIDs.concat([receiver.getID()]));
        };
        _this.getAdmins = function () {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return latestChunk.getAdmins();
        };
        _this.setAdmins = function (admins) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return _this.createSuccessor(latestChunk.getReceiver(), { admins: admins });
        };
        _this.addReceivers = function (newReceiverIDs, canReadOldMessages) {
            if (canReadOldMessages === void 0) { canReadOldMessages = false; }
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            var oldReceivers = latestChunk.getReceiver();
            return _this.createSuccessor(oldReceivers.concat(newReceiverIDs), { canReadOldMessages: canReadOldMessages });
        };
        _this.loadAllChunks = function () {
            return socketService.emit("chat.getChunks", { id: _this.id }).then(function (_a) {
                var chunks = _a.chunks;
                return chunks;
            }).map(function (chunk) {
                return ChunkLoader.load(chunk);
            });
        };
        _this.encryptAllChunksForReceiver = function (chunkData, addedReceiver) {
            return _this.loadAllChunks().then(function (chunks) {
                chunks.sort(function (c1, c2) { return c1.getID() - c2.getID(); });
                chunks.forEach(function (chunk, index) {
                    if (chunks[index + 1] && chunks[index + 1].getPredecessorID() !== chunk.getID()) {
                        throw new Error("chunk chain invalid");
                    }
                });
                var receiverKeys = addedReceiver.map(function (receiver) {
                    return chunkData.receiverKeys[receiver];
                });
                var chunkKeys = chunks.map(function (chunk) { return chunk.getSecuredData().metaAttr("_key"); }).filter(function (value, index, self) {
                    return self.indexOf(value) === index;
                });
                return Bluebird.all(receiverKeys.map(function (receiverKey) {
                    return Bluebird.all(chunkKeys.map(function (chunkKey) {
                        return keyStore.sym.symEncryptKey(chunkKey, receiverKey);
                    }));
                })).thenReturn([chunkKeys, receiverKeys]);
            }).then(function (_a) {
                var chunkKeys = _a[0], receiverKeys = _a[1];
                return __assign({}, chunkData, { previousChunksDecryptors: keyStore.upload.getDecryptors(chunkKeys, receiverKeys) });
            });
        };
        _this.createSuccessor = function (receiver, options) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            var _a = options.canReadOldMessages, canReadOldMessages = _a === void 0 ? false : _a, _b = options.title, title = _b === void 0 ? latestChunk.getTitle() : _b, _c = options.admins, admins = _c === void 0 ? latestChunk.getAdmins() : _c;
            if (!latestChunk.amIAdmin()) {
                throw new Error("Not an admin of this chunk");
            }
            var addedReceiver = receiver.filter(function (id) { return latestChunk.getReceiver().indexOf(id) === -1; });
            var removedReceiver = latestChunk.getReceiver().filter(function (id) { return receiver.indexOf(id) === -1; });
            if (removedReceiver.length > 0 && canReadOldMessages) {
                throw new Error("Can not remove receiver and allow reading of old messages");
            }
            return latestChunk.getSuccessor().then(function (successor) {
                if (successor) {
                    throw new Error("TODO: Chunk has a successor. Try again?");
                }
                var content = { title: title };
                var meta = { admins: admins };
                var newKey = addedReceiver.length > 0 || removedReceiver.length > 0;
                return Chunk.createRawData(receiver, {
                    content: content,
                    meta: meta,
                    predecessorChunk: latestChunk,
                    givenKey: !newKey && latestChunk ? latestChunk.getKey() : null
                });
            }).then(function (chunkData) {
                if (!canReadOldMessages || addedReceiver.length === 0) {
                    return chunkData;
                }
                return _this.encryptAllChunksForReceiver(chunkData, addedReceiver);
            }).then(function (_a) {
                var chunk = _a.chunk, keys = _a.keys, receiverKeys = _a.receiverKeys, previousChunksDecryptors = _a.previousChunksDecryptors;
                return socketService.emit("chat.chunk.create", {
                    predecessorID: latestChunk.getID(),
                    chunk: chunk,
                    keys: keys,
                    receiverKeys: receiverKeys,
                    previousChunksDecryptors: previousChunksDecryptors,
                    canReadOldMessages: canReadOldMessages
                });
            }).then(function (response) {
                return ChunkLoader.load(response.chunk);
            }).then(function (chunk) {
                _this.addChunkID(chunk.getID());
            });
        };
        _this.setTitle = function (title) {
            var latestChunk = ChunkLoader.getLoaded(_this.getLatestChunk());
            return _this.createSuccessor(latestChunk.getReceiverIDs(), { title: title });
        };
        _this.sendUnsentMessage = function (messageData, files) {
            if (files.length > 0) {
                return;
            }
            return _this.sendMessage(messageData.message, { images: [], files: [], voicemails: [] }, messageData.id);
        };
        _this.storeMessage = function (messageObject, message, id) {
            if (id) {
                return Bluebird.resolve();
            }
            if (_this.draft) {
                return Bluebird.resolve();
            }
            if (messageObject.hasAttachments()) {
                return Bluebird.resolve();
            }
            return Bluebird.try(function () {
                return messageSendCache.store(messageObject.getClientID(), {
                    chatID: _this.getID(),
                    id: messageObject.getClientID(),
                    message: message
                });
            });
        };
        _this.isDraft = function () { return _this.draft; };
        _this.sendMessage = function (message, attachments, id) {
            var messageObject = new Message(message, _this, attachments, id);
            MessageLoader.addLoaded(messageObject.getClientID(), messageObject);
            _this.addMessageID(messageObject.getClientID(), Number.MAX_SAFE_INTEGER);
            return _this.storeMessage(messageObject, message, id).finally(function () {
                var sendMessagePromise = messageObject.sendContinously();
                sendMessagePromise.then(function () {
                    _this.removeMessageID(messageObject.getClientID());
                    _this.addMessage(messageObject);
                    return messageSendCache.delete(messageObject.getClientID());
                });
                sendMessagePromise.catch(function (e) {
                    console.error(e);
                    alert("An error occured sending a message!" + e.toString());
                });
                return sendMessagePromise;
            });
        };
        _this.id = id;
        _this.draft = draft;
        _this.update({ latestChunk: latestChunk, latestMessage: latestMessage, unreadMessageIDs: unreadMessageIDs });
        return _this;
    }
    Chat.prototype.isUnread = function () {
        return unreadChatIDs.indexOf(this.id) > -1;
    };
    Chat.prototype.loadOlderMessages = function (message, limit) {
        var _this = this;
        if (limit === void 0) { limit = 20; }
        return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            var messagesFromCache, _a, messages, _b, chunks, remainingMessagesCount, messagesObjects;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!message) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadPreviousMessagesFromCache(message, limit)];
                    case 1:
                        messagesFromCache = _c.sent();
                        limit -= messagesFromCache.length;
                        if (limit < 1) {
                            return [2 /*return*/];
                        }
                        if (messagesFromCache.length > 0) {
                            message = h.array.last(messagesFromCache);
                        }
                        _c.label = 2;
                    case 2: return [4 /*yield*/, socketService.definitlyEmit("chat.getMessages", {
                            id: this.getID(),
                            oldestKnownMessage: message ? message.getServerID() : 0,
                            limit: limit
                        })];
                    case 3:
                        _a = _c.sent(), messages = _a.messages, _b = _a.chunks, chunks = _b === void 0 ? [] : _b, remainingMessagesCount = _a.remainingMessagesCount;
                        return [4 /*yield*/, Bluebird.all(chunks.map(function (chunk) { return ChunkLoader.load(chunk); }))];
                    case 4:
                        _c.sent();
                        return [4 /*yield*/, Bluebird.all(messages.map(function (message) { return MessageLoader.load(message); }))];
                    case 5:
                        messagesObjects = _c.sent();
                        return [4 /*yield*/, Bluebird.all(messagesObjects.map(function (message) { return _this.verifyMessageAssociations(message); }))];
                    case 6:
                        _c.sent();
                        messagesObjects.forEach(function (message) {
                            return _this.addMessage(message);
                        });
                        return [2 /*return*/, remainingMessagesCount];
                }
            });
        }); });
    };
    Chat.prototype.loadMoreMessages = function () {
        if (this.draft) {
            return Bluebird.resolve(0);
        }
        var oldestKnownMessage = this.messages.length === 0 ? null : MessageLoader.getLoaded(this.messages[0].id);
        return this.loadOlderMessages(oldestKnownMessage);
    };
    Chat.prototype.getMessages = function () {
        return this.messages;
    };
    Chat.prototype.getChatUpdates = function () {
        return this.chatUpdates;
    };
    Chat.prototype.getLatestChatUpdate = function () {
        if (this.chatUpdates.length > 0) {
            return h.array.last(this.chatUpdates).id;
        }
    };
    Chat.prototype.getLatestChunk = function () {
        return h.array.last(this.chunkIDs);
    };
    Chat.prototype.getLatestMessage = function () {
        if (this.messages.length > 0) {
            return h.array.last(this.messages).id;
        }
    };
    Chat.prototype.getLatestSentMessage = function () {
        var messages = this.messages.map(function (_a) {
            var id = _a.id;
            return MessageLoader.getLoaded(id);
        }).filter(function (m) { return m.hasBeenSent(); });
        if (messages.length > 0) {
            return h.array.last(messages).getClientID();
        }
    };
    Chat.prototype.localMarkRead = function () {
        var _this = this;
        if (this.unreadMessageIDs.length === 0 && unreadChatIDs.indexOf(this.id) === -1) {
            return;
        }
        this.unreadMessageIDs = [];
        unreadChatIDs = unreadChatIDs.filter(function (id) { return id !== _this.id; });
        this.notify(this.getID(), "read");
        this.store();
    };
    Chat.prototype.markRead = function () {
        this.localMarkRead();
        if (this.draft) {
            return Bluebird.resolve();
        }
        return socketService.definitlyEmit("chat.markRead", { id: this.id });
    };
    Chat.prototype.addUnreadMessage = function (id) {
        if (this.unreadMessageIDs.indexOf(id) === -1) {
            this.unreadMessageIDs.push(id);
        }
        if (unreadChatIDs.indexOf(this.id) === -1) {
            unreadChatIDs.push(this.id);
        }
        this.store();
    };
    Chat.getUnreadChatIDs = function () {
        return unreadChatIDs;
    };
    return Chat;
}(Observer));
export { Chat };
var loadChatInfo = function (ids) {
    return socketService.definitlyEmit("chat.getMultiple", { ids: ids })
        .then(function (_a) {
        var chats = _a.chats;
        return ids.map(function (id) { return chats.find(function (_a) {
            var chat = _a.chat;
            return h.parseDecimal(chat.id) === h.parseDecimal(id);
        }); });
    });
};
var getChatInfo = h.delayMultiplePromise(Bluebird, 50, loadChatInfo, 10);
var ChatLoader = /** @class */ (function (_super) {
    __extends(ChatLoader, _super);
    function ChatLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ChatLoader;
}(ObjectLoader({
    download: function (id) {
        return getChatInfo(id).then(function (chatInfo) {
            if (h.parseDecimal(chatInfo.chat.id) !== h.parseDecimal(id)) {
                throw new Error("Chat ID incorrect after loading. Should be " + id + " but is " + chatInfo.chat.id);
            }
            return chatInfo;
        });
    },
    load: function (chatResponse, previousInstance) {
        if (previousInstance && h.deepEqual(previousInstance.getInfo(), chatResponse.chat)) {
            return Bluebird.resolve(SYMBOL_UNCHANGED);
        }
        var loadChunks = Bluebird.all(chatResponse.chunks.map(function (chunkData) {
            return ChunkLoader.load(chunkData);
        }));
        var loadMessages = Bluebird.all(chatResponse.messages.map(function (messageData) {
            return MessageLoader.load(messageData);
        }));
        var _a = chatResponse.chat, id = _a.id, latestMessageID = _a.latestMessageID, latestChunkID = _a.latestChunkID, unreadMessageIDs = _a.unreadMessageIDs;
        return Bluebird.all([
            loadChunks,
            loadMessages,
        ]).thenReturn({ id: id, latestMessageID: latestMessageID, latestChunkID: latestChunkID, unreadMessageIDs: unreadMessageIDs });
    },
    getID: function (response) { return response.chat.id; },
    restore: function (chatInfo, previousInstance) {
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var id, latestMessageID, latestChunkID, unreadMessageIDs, latestMessage, _a, latestChunk;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            id = chatInfo.id, latestMessageID = chatInfo.latestMessageID, latestChunkID = chatInfo.latestChunkID, unreadMessageIDs = chatInfo.unreadMessageIDs;
                            if (!latestMessageID) return [3 /*break*/, 2];
                            return [4 /*yield*/, MessageLoader.get(latestMessageID)];
                        case 1:
                            _a = _b.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = null;
                            _b.label = 3;
                        case 3:
                            latestMessage = _a;
                            return [4 /*yield*/, ChunkLoader.get(latestChunkID)];
                        case 4:
                            latestChunk = _b.sent();
                            if (!latestMessage) return [3 /*break*/, 6];
                            return [4 /*yield*/, verifyMessageAssociations(latestMessage, latestChunk.getID())];
                        case 5:
                            _b.sent();
                            _b.label = 6;
                        case 6:
                            if (previousInstance) {
                                previousInstance.update({ unreadMessageIDs: unreadMessageIDs, latestMessage: latestMessage, latestChunk: latestChunk });
                                return [2 /*return*/, previousInstance];
                            }
                            return [2 /*return*/, new Chat({
                                    id: id,
                                    latestMessage: latestMessage,
                                    latestChunk: latestChunk,
                                    unreadMessageIDs: unreadMessageIDs
                                })];
                    }
                });
            });
        });
    },
    shouldUpdate: function (_event, instance) { return Bluebird.resolve(!instance.isDraft()); },
    cacheName: "chat"
})));
export default ChatLoader;
var lastLoaded = 0;
var setUnreadChatIDs = function (unreadIDs) {
    var chats = ChatLoader.getAll();
    Object.keys(chats).forEach(function (id) {
        var chat = chats[id].instance;
        if (unreadIDs.indexOf(chat.getID()) !== -1) {
            return;
        }
        chat.localMarkRead();
    });
    unreadChatIDs = unreadIDs;
};
socketService.channel("unreadChats", function (e, data) {
    if (e) {
        console.warn(e);
    }
    if (!data.unreadChatIDs) {
        console.warn("got no chat ids from socket channel");
        return;
    }
    setUnreadChatIDs(data.unreadChatIDs);
});
var loadUnreadChatIDs = function () {
    if (new Date().getTime() - lastLoaded < 5 * 1000) {
        return;
    }
    return initService.awaitLoading().then(function () {
        return Bluebird.delay(500);
    }).then(function () {
        return socketService.awaitConnection();
    }).then(function () {
        return socketService.emit("chat.getUnreadIDs", {});
    }).then(function (data) {
        if (!data.chatIDs) {
            console.warn("got no chat ids from socket request");
            return;
        }
        setUnreadChatIDs(data.chatIDs);
    });
};
socketService.on("connect", function () {
    loadUnreadChatIDs();
});
initService.listen(function () {
    loadUnreadChatIDs();
}, "initDone");



//////////////////
// WEBPACK FOOTER
// ./js/messages/chat.ts
// module id = aJMM
// module chunks = 1